<template>
  <settings-menu-layout>
    <row>
      <col12>
      {{details}}
        <text-in-modal  v-if="details" :text="details" @close_modal="showDetails(null)"></text-in-modal>

        <v-text-field
          :label="$t('set_jobs.search')"
          prepend-inner-icon="mdi-magnify"
          v-model="filter" />
        
        <v-card class="mb-3 pa-2">
          <v-card-title class="py-2 px-3 text-caption">{{ $t('set_jobs.job_types') }}</v-card-title>
          <v-card-text class="py-2 px-3">
            <v-row dense align="start">
              <v-col cols="12" sm="6" md="3" lg="2" v-for="jobType in availableJobTypes" :key="jobType.value">
                <v-checkbox
                  v-model="selectedJobTypes"
                  :label="jobType.label"
                  :value="jobType.value"
                  @change="updateTaskTypes"
                  dense
                  hide-details
                  class="ma-0 pa-0 text-caption"
                  label-class="text-caption font-size-small"
                ></v-checkbox>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>

        <v-card class="mb-3 pa-2">
          <v-card-text class="py-2 px-3">
            <v-checkbox
              v-model="show_unclaimed_only"
              :label="$t('set_jobs.show_unclaimed_only')"
              dense
              hide-details
              class="ma-0 pa-0"
            ></v-checkbox>
          </v-card-text>
        </v-card>

        <v-data-table
          :loading="loading"
          :items="items"
          :server-items-length="totalItems"
          :headers="headers"
          :options.sync="options"
        >
          <template v-slot:item="{ item }">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <tr v-bind="attrs" v-on="on">
                  <td>{{ item.task }}</td>
                  <td>
                    <div @click="showDetails(item.description)">{{ item.description.substring(0, 30) }} ...</div>
                  </td>
                  <td>{{ item.created_at }}</td>
                  <td>{{ item.progress }}</td>
                  <td>{{ item.processed }}</td>
                  <td>
                    <div v-if="item.claimed_at">
                      {{ formatDate(item.claimed_at) }}
                    </div>
                    <div v-else style="color: #999;">
                      {{ $t('set_jobs.not_claimed') }}
                    </div>
                  </td>
                  <td>
                    <div v-if="item.on_hold" style="color: #ff9800; font-weight: bold;">
                      <v-icon small class="mr-1" color="orange">mdi-pause-circle</v-icon>
                      {{ $t('set_jobs.on_hold_yes') }}
                    </div>
                    <div v-else style="color: #4caf50;">
                      <v-icon small class="mr-1" color="green">mdi-play-circle</v-icon>
                      {{ $t('set_jobs.on_hold_no') }}
                    </div>
                  </td>
                  <td>
                    <div v-if="item.logs" @click="showDetails(item.logs)" style="cursor: pointer; color: #1976d2;">
                      <v-icon small class="mr-1">mdi-text-box-outline</v-icon>
                      {{ $t('set_jobs.view_logs') }}
                    </div>
                    <div v-else style="color: #999;">
                      {{ $t('set_jobs.no_logs') }}
                    </div>
                  </td>
                  <td>
                    <v-icon
                      small
                      class="mr-2"
                      @click="delete_job(item)"
                    >
                      far fa-trash-alt
                    </v-icon>
                  </td>
                </tr>
              </template>
              <span>Job ID: {{ item.id }}</span>
            </v-tooltip>
          </template>
        </v-data-table>
      </col12>
    </row>
  </settings-menu-layout>
</template>

<script>
  import SettingsMenuLayout from "@/components/layout/SettingsMenuLayout";
  import Col12 from "@/components/layout/Col12";
  import Row from "@/components/layout/Row";
  import ApiDatatableMixin from "@/mixins/ApiDatatableMixin";
  import TextInModal from "@/components/TextInModal.vue";

  export default {
    name: "SettingsJobs",
    mixins: [ApiDatatableMixin],
    data () {
      return {
        'api_model': 'job',
        'details': null,
        'selectedJobTypes': ['run_model'],
        'availableJobTypes': [
          { value: 'run_model', label: 'Run Model' },
          { value: 'calculate_annotation_stats', label: 'Calculate Annotation Stats' },
          { value: 'calculate_conf_matrix_items', label: 'Calculate Confusion Matrix Items' },
          { value: 'calculate_performance_job', label: 'Calculate Performance Job' },
          { value: 'full_calculate_confusion_matrix', label: 'Full Calculate Confusion Matrix' },
          { value: 'train', label: 'Train' },
          { value: 'export', label: 'Export' },
          { value: 'evaluate', label: 'Evaluate' }
        ]
      }
    },
    mounted() {
      this.updateTaskTypes();
    },
    computed: {
      headers(){
        return [
        {text: this.$t('set_jobs.task'), value: 'task'},
        {text: this.$t('set_jobs.description'), value: 'description'},
        {text: this.$t('set_jobs.created_at'), value: 'created_at'},
        {text: this.$t('set_jobs.progress'), value: 'progress'},
        {text: this.$t('set_jobs.processed'), value: 'processed'},
        {text: this.$t('set_jobs.claimed_at'), value: 'claimed_at'},
        {text: this.$t('set_jobs.on_hold'), value: 'on_hold'},
        {text: this.$t('set_jobs.logs'), value: 'logs', sortable: false},
        {text: this.$t('set_jobs.actions'), value: 'actions', sortable: false},
        ]
      }
    },
    methods: {
      showDetails(details) {
        this.$set(this, 'details', details)
      },
      async delete_job(item) {
        this.$set(this, 'loading', true);
        await this.$api.job.delete(item);
        await this.loadItems();
        this.$set(this, 'loading', false);
      },
      updateTaskTypes() {
        this.$set(this, 'task_types', this.selectedJobTypes);
      },
      formatDate(dateString) {
        if (!dateString) return '';
        const date = new Date(dateString);
        return date.toLocaleString();
      }
    },
    components: {
      TextInModal,
      Row,
      Col12,
      SettingsMenuLayout},
  }
</script>

<style scoped>
.font-size-small {
  font-size: 0.75rem !important;
}
</style>